import ChartTimezoneGroupActionsUtils from '@/common/components/chart/chart-timezone-group-actions';
import CellType from '@/common/enums/cell-type.enum';
import TimeGranularity from '@/common/enums/time-granularity.enum';
import Exception from '@/common/models/Exception';

export default class TimeseriesAxisX {
  axisLabel: string | null;

  cellType: string | null;

  data: never[] = [];

  granularity: TimeGranularity.HOURLY | TimeGranularity.DAILY | TimeGranularity.MONTHLY | TimeGranularity.YEARLY | null;

  min: number | null;

  name: string | null;

  nameTextStyle: {
    color: string;
    borderColor: string;
  };

  raw: never[] = [];

  show: boolean;

  transform: (val) => val;

  tz: string | null;

  constructor(
    axisLabel = null,
    cellType = null,
    data = [], // formatted data, the way you want to see it appear on the axis
    granularity = null, // what TimeGranularity you are using
    min = null,
    name = null,
    nameTextStyle = {},
    raw = [], // raw data, for timestamp, use millis
    show = true,
    transform = (val) => val, // the function that will transform your raw data to the formatted data
    tz = null, // the timezone you want to apply to your xAxis
  ) {
    this.axisLabel = axisLabel;
    this.cellType = cellType;
    this.data = data;
    this.granularity = granularity;
    this.min = min;
    this.name = name;
    this.nameTextStyle = nameTextStyle;
    this.raw = raw;
    this.show = show;
    this.transform = transform;
    this.tz = tz;
  }

  static fromObject(obj): TimeseriesAxisX {
    const validProps: string[] = [
      'axisLabel',
      'cellType',
      'data',
      'granularity',
      'min',
      'name',
      'nameTextStyle',
      'raw',
      'show',
      'transform',
      'tz',
    ];
    const requiredProps: string[] = ['data', 'granularity', 'name', 'raw', 'transform'];

    const invalidProps: string[] = Object.keys(obj).filter((key) => !validProps.includes(key));

    if (invalidProps.length) {
      throw new Exception(`Invalid properties: ${invalidProps.join(', ')}`);
    }

    const missingProps: string[] = requiredProps.filter((prop) => !Object.keys(obj).includes(prop));

    if (missingProps.length) {
      throw new Exception(`Missing required properties: ${missingProps.join(', ')}`);
    }

    return new TimeseriesAxisX(
      obj?.axisLabel || { show: true },
      CellType.DATE_TIME,
      obj.data,
      obj.granularity,
      obj?.min,
      obj.name,
      obj?.nameTextStyle || { color: 'transparent', borderColor: 'transparent' },
      obj.raw,
      obj?.show === 'undefined' || true,
      obj.transform,
      obj?.tz || ChartTimezoneGroupActionsUtils.defaultTz,
    );
  }
}
